export const theme = {
  name: 'Pipes n Stuff',
  author: {
    name: 'Strategic Projects',
    profile_url: 'https://entersekt.com'
  }
};
